
import React from "react";
import SideMenu from "./SideMenu";

import { Helmet } from "react-helmet-async";

const AdminProfile = ({children}) => {

  const menuItems = [
    { name: "Dashboard", url: "/admin/dashboard" },
    { name: "New Product", url: "/admin/product/new" },
    { name: "New Blog", url: "/admin/blogs/new" },
    { name: "Products", url: "/admin/products" },
    { name: "Blogs", url: "/admin/blogs" },
    { name: "Orders", url: "/admin/orders" },
    { name: "Users", url: "/admin/users" },
    { name: "Reviews", url: "/admin/reviews" },
    { name: "Comments", url: "/admin/comments" },
  ];



  return (
    <>
      <Helmet>
        <title>My Profile</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className="w-full mt-20  md:mt-32 mx-auto md:flex my-22 px-6 py-12 bg-[#f5f3ea] shadow-md rounded-md">
        <SideMenu menuItems={menuItems}/>

        <div className="flex flex-col md:space-y-6 w-full md:px-8 mt-8 md:mt-0 bg-white/70 backdrop-blur-sm p-6 rounded-md shadow-inner">
         {children}
        </div>
      </section>
    </>
  );
};

export default AdminProfile;

